import { useCallback, useState } from 'react';
import { readStorage, writeStorage } from '../lib/storage';

/**
 * useState that survives leaving the page: the value is kept in localStorage under `key`.
 * `allowed` lists the values that may come back from storage; anything else means `initial`.
 */
export function useStoredState<T extends string>(key: string, initial: T, allowed: readonly T[]): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    const stored = readStorage(key);
    return allowed.find((option) => option === stored) ?? initial;
  });
  const set = useCallback(
    (next: T) => {
      setValue(next);
      writeStorage(key, next);
    },
    [key],
  );
  return [value, set];
}
